import Environment from '@interfaces/environment.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

interface IGetMediaContents {
  idCampaign: string
  status?: string | string[] | null
  socialId?: string | null
}

export default class EdnaService extends MainService {
  url: string
  logService = new LogService()

  constructor(ednaUrl?: string) {
    super()
    if (!ednaUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.edna
      })
    } else {
      this.url = ednaUrl
    }
    this.logService.init('Edna Service')
  }

  async getMediaContents({ idCampaign, socialId = null, status = null }: IGetMediaContents) {
    const headers = await this.getHeaders()
    const params = new URLSearchParams()
    if (socialId) {
      params.append('socialId', socialId)
    }
    if (status) {
      if (Array.isArray(status)) {
        status.forEach((s) => params.append('status', s))
      } else {
        params.append('status', status)
      }
    }
    return this.http
      .get(`${this.url}/hub/contents/${idCampaign}?${params?.toString()}`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Can not get medias',
          error,
        })
        throw error.response
      })
  }

  async generateSignedURL(idCampaign: string, payload: any) {
    const headers = await this.getHeaders()

    return this.http
      .post(`${this.url}/hub/content/signed-url/${idCampaign}`, payload, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Failed to generate signed URL',
          error,
        })
        throw error.response
      })
  }

  async putMediaContent(payload) {
    const headers = await this.getHeaders()

    return this.http
      .put(`${this.url}/hub/media/content`, payload, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Failed to change media content',
          error,
        })
        throw error.response
      })
  }

  async postMediaContent(payload) {
    const headers = await this.getHeaders()

    return this.http
      .post(`${this.url}/hub/media/content`, payload, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Failed to send media content',
          error,
        })
        throw error.response
      })
  }
}
